<script>
	import OffCanvas from './OtherSkills.svelte';
    export let color = {
        hex: "#6f42c1",
        name: "purple",
    }

    export let isEducation = true;

    export let timelineHeading = {
        title: "Title",
        "subtitle": "Subtitle"
    };

    let details;

    if (isEducation) {
        details = [
            {
                "institution": "Some XCompany, USA",
                "degree": "Bachelor of Science",
                "major": "Computer Engineering",
                "graduation": "2015",
            },
            {
                "institution": "Some YCompany, USA",
                "degree": "Uganda Advanced Certificate of Education",
                "major": "Physics, Chemistry, Mathematics and Entrepreneurship",
                "graduation": "2009",
            },
            {
                "institution": "Microverse, USA",
                "degree": "Software Engineering",
                "major": "Ruby on Rails, MERN Stack",
                "graduation": "2020",
            }
        ];
    } else {
       details = [
            {
                "institution": "Some XCompany, USA",
                "start": "2019",
                "end": "2020",
                "title": "Software Developer",
                "stack": "Ruby on Rails, MERN Stack",
                "jobDescription": [
                  "Developed a web application for students to manage their thesis.",
                  "Developed a web application for students to manage their thesis.",
                  "Developed a web application for students to manage their thesis.",
                  "Developed a web application for students to manage their thesis.",
                  "Developed a web application for students to manage their thesis.",
                ]
            }
        ];
    }

    export let timelineDetails = details;

</script>

{#if isEducation}
<h2 class="pb-1 border-bottom mt-3">{timelineHeading.title} <small class="text-{color.name}">({timelineHeading.subtitle})</small></h2>
			<ul class="timeline">
				{#each timelineDetails as detail}
                <li>
					<p>
                        <span>{detail.institution} - <b class="text-{color.name}">{detail.degree}</b></span> |
                        <span>{detail.major}</span> |
                        <span>{detail.graduation}</span>
                    </p>
                    {#if detail.description}
                    <p>{detail.description}</p>
                    {/if}
				</li>
                {/each}
			</ul>
{:else}
<h2 class="pb-1 border-bottom mt-3">{timelineHeading.title}  <small class="text-{color.name}">({timelineHeading.subtitle})</small></h2>
            <ul class="timeline">
                {#each timelineDetails as detail}
                <li>
                    <p>
                        <span class="text-{color.name}">{detail.title}</span>, <em class="text-muted">{detail.start} - {detail.end}</em><br>
                        <b>{detail.institution}</b><br>
                        <em>Stack: {detail.stack}</em>
                    </p>
                    <ul>
                        {#each detail.jobDescription as job}
                        <li>{job}</li>
                        {/each}
                    </ul>
                </li>
                {/each}
            </ul>
{/if}

<style>
    ul.timeline {
    list-style-type: none;
    position: relative;
}
ul.timeline:before {
    content: ' ';
    background: #d4d9df;
    display: inline-block;
    position: absolute;
    left: 29px;
    width: 2px;
    height: 100%;
    z-index: 400;
}
ul.timeline > li {
    margin: 20px 0;
    padding-left: 20px;
}
ul.timeline > li:before {
    content: ' ';
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid gray;
    left: 20px;
    width: 20px;
    height: 20px;
    z-index: 400;
}
</style>